import { InvestigationStatus } from '@/api/ariadne/__generated_types__/apollo';
import { LicensePayment } from '@/top-level-tot/types';
import {
  GetContextMenuItemsParams,
  MenuItemDef,
} from '@ag-grid-community/core';
import { ContextMenuItemsExtensions } from '../types';

// We cannot use @heroicons (which is a React component) since icons only accept strings or DOM elements
const checkCircleIcon =
  '<svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>';

export function markAsInvestigated(
  params: GetContextMenuItemsParams,
  onMarkAsInvestigated?: ContextMenuItemsExtensions['onMarkAsInvestigated']
): MenuItemDef | undefined {
  const rowData: LicensePayment | undefined = params?.node?.data;
  const hasTaxDiscrepancy = rowData?.taxEstimation?.hasTaxDiscrepancy;

  // Don't show the option if there is no tax discrepancy
  if (!hasTaxDiscrepancy) {
    return undefined;
  }

  // Don't show the option if the discrepancy has already been investigated
  if (rowData?.discrepancyInvestigated === InvestigationStatus.Investigated) {
    return undefined;
  }

  return {
    name: 'Mark as investigated',
    icon: checkCircleIcon,
    disabled: !rowData,
    action: () => {
      if (onMarkAsInvestigated && rowData) {
        onMarkAsInvestigated(rowData.id);
      }
    },
  };
}
